global.restServer = process.env.REACT_APP_SCOP_API_URL || "http://localhost:9080";
// global.restServer = "https://scop.mrc-lmb.cam.ac.uk/api";

global.GA_TRACKING_ID = ""; //"UA-153541970-1"; // SCOP EKMM Ltd
global.GA_TRACKING_ID = ""; //"UA-147377191-1"; // SCOP
